<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}"
              label="设备"
              prop="devid"
            >
              <j-tree-select-device
                :getPopupContainer="getModalAsContainer"
                :multiple="true"
                @change="changeDevs"
                placeholder="请选择设备"
                v-model="model.devid"
              ></j-tree-select-device>
            </a-form-model-item>
          </a-col>
          <a-col :span="23" v-show="!!model.devid">
            <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
              <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择设备(表号)：
              <span style="font-weight: 600">{{ devTags }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备组名称" prop="groupName">
              <a-input placeholder="请输入设备组名称" v-model="model.groupName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备组表号" prop="groupTag">
              <a-input placeholder="请输入设备组表号" v-model="model.groupTag"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item
              :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}"
              label="切换方式"
              prop="switchType"
            >
              <j-dict-select-tag
                dictCode="dev_switch_type"
                placeholder="请选择切换方式"
                type="radioButton"
                v-model="model.switchType"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-show="false ">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运行时长(分钟)" prop="runningTime">
              <a-input-number placeholder="请输入运行时长" style="width: 100%" v-model="model.runningTime" />
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="切换周期" prop="cycle">
              <a-input-number placeholder="请输入切换周期" style="width: 100%" v-model="model.cycle" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="周期单位" prop="cycleUnit">
              <j-dict-select-tag
                dictCode="dev_switch_cycle"
                placeholder="请选择周期单位"
                type="radioButton"
                v-model="model.cycleUnit"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-show="model.switchType === 'cycle' ">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上次切换时间" prop="lastTime">
              <j-date
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择上次切换时间"
                style="width: 100%"
                v-model="model.lastTime"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-show="model.switchType === 'cycle' ">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="下次切换时间" prop="nextTime">
              <j-date
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择下次切换时间"
                style="width: 100%"
                v-model="model.nextTime"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划状态" prop="planStatus">
              <j-switch v-model="model.planStatus"></j-switch>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction, postAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { LCS } from '@/utils/lcs'
  export default {
    name: 'DevSwitchPlanForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        devTags: '',
        model: {
          switchType: 'cycle',
          cycleUnit: "10080",
          cycle: 1,
          groupName: '',
          planStatus: 'Y',
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          groupName: [
            { required: true, message: '请输入设备组名称!' },
          ],
          cycle: [
            { required: true, message: '请输入切换周期!' },
            { pattern: /^-?\d+\.?\d*$/, message: '请输入数字!' },
          ],
          cycleUnit: [
            { required: true, message: '请输入周期单位!' },
          ],
        },
        url: {
          add: "/maintenance/devSwitch/add",
          edit: "/maintenance/devSwitch/edit",
          queryById: "/maintenance/devSwitch/queryById",
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            if (this.model.switchType === 'cycle') {
              this.model.cycleHours = this.model.cycle * this.model.cycleUnit / 60;
            } else {
              this.model.runningTime = this.model.cycle * this.model.cycleUnit;
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      changeDevs (thisId, values) {
        if (values.length === 0) {
          this.model.groupName = '';
          return;
        }
        if (values.length === 1) {
          this.model.groupName = this.model.groupName || values[0].label
          return;
        }
        const longestSubStr = LCS(values[0].label, values[1].label);
        this.model.groupName = longestSubStr;

        const devIds = values.map(item => item.value);
        postAction(`/device/devList/getDevListByIds`, devIds).then(res => {
          if (res.success) {
            const result = res.result.map(item => item.devTag)
            this.devTags = result.join('    ')
          }
        });

      },
      getModalAsContainer (node) {
        return node.parentNode.parentNode.parentNode
      },
    }
  }
</script>